import React, { useState, ChangeEvent, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoginFormData } from '../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';

const Login: React.FC = () => {
  const [formData, setFormData] = useState<LoginFormData>({
    email: '',
    password: ''
  });
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);
    
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error || 'Login failed');
    }
    
    setLoading(false);
  };

  return (
    <div className="container">
      <div className="text-center mt-4">
        <h1>ZeaOne Admin Dashboard</h1>
        <h2>Login</h2>
      </div>
      
      <div className="card" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button 
            type="submit" 
            style={{ 
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#16a34a',
              border: '2px solid white',
              borderRadius: '8px',
              color: 'white',
              padding: '0',
              fontSize: '14px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              cursor: 'pointer',
              overflow: 'hidden',
              width: '100%',
              minHeight: '48px',
              opacity: loading ? 0.7 : 1
            }}
            disabled={loading}
          >
            <div style={{
              backgroundColor: '#16a34a',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRight: '1px solid rgba(255,255,255,0.3)'
            }}>
              <FontAwesomeIcon icon={faSignInAlt} style={{ fontSize: '16px' }} />
            </div>
            <div style={{
              padding: '12px',
              flex: 1,
              textAlign: 'center'
            }}>
              {loading ? 'LOGGING IN...' : 'LOGIN'}
            </div>
          </button>
        </form>
        
        <div className="text-center mt-4">
          <p>
            Don't have an account? <Link to="/signup">Sign up here</Link>
          </p>
          <p style={{ marginTop: '12px' }}>
            <Link to="/docs" style={{ color: '#3b82f6', textDecoration: 'none' }}>
              📚 View Integration Documentation
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
